var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "income-wrapper" },
    [
      _c("div", { staticClass: "item" }, [
        _c("span", { staticClass: "icon" }),
        _vm._v(" "),
        _c("div", { staticClass: "token-wrapper" }, [
          _c("div", { staticClass: "token-title" }, [
            _vm._v(_vm._s(_vm.$t("tradeOperator.totalIncome")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "token-amount" }, [
            _vm._v(_vm._s(_vm.totalAmount))
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._l(_vm.typeList, function(type, i) {
        return _c("div", { key: i, staticClass: "item" }, [
          _c("img", { staticClass: "icon", attrs: { src: type.icon } }),
          _vm._v(" "),
          _c("div", { staticClass: "token-wrapper" }, [
            _c("div", { staticClass: "token-title" }, [
              _vm._v(_vm._s(type.name))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "token-amount" }, [
              _vm._v(
                _vm._s(
                  _vm.income && _vm.income[type.name]
                    ? _vm.formatNum(_vm.income[type.name].amount)
                    : "0"
                )
              )
            ])
          ])
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }